import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/map_placeholder.webp")